import { buildSageIdLoginUrl, fetchSession } from './connectorApi';
import { mapSessionError, mapSessionResponse } from './mapSessionResponse';
import { runSyncFlow } from './runSyncFlow';
import { refreshSessionCache } from './refreshSessionCache';
import { BLOCKER_CODES } from './constants';
import { getSessionCache, setSessionCache, clearSessionCache } from './sessionCache';

export const resetOnboardingSession = () => {
    clearSessionCache();
};

export const redirectToSageIdLogin = () => {
    window.location.href = buildSageIdLoginUrl();
};

export const bootstrap = async (params = {}) => {
    const sessionId = params.sessionId;
    if (!sessionId) {
        return { success: false, errorCode: BLOCKER_CODES.INVALID_CONTEXT };
    }

    try {
        const { data } = await fetchSession(sessionId);
        const result = mapSessionResponse(data, sessionId);

        if (result.sessionCache) {
            setSessionCache(result.sessionCache);
        }

        const { sessionCache: _sessionCache, ...bootstrapResult } = result;
        return bootstrapResult;
    } catch (error) {
        return mapSessionError(error);
    }
};

export const getCompanies = async ({ sessionId } = {}) => {
    const cache = getSessionCache();

    if (cache?.companies) {
        return { success: true, companies: cache.companies };
    }

    const refreshed = await refreshSessionCache(sessionId);

    if (refreshed.needsSageIdLogin) {
        return { success: false, needsSageIdLogin: true };
    }

    if (!refreshed.success) {
        return {
            success: false,
            errorCode: refreshed.errorCode,
            needsSageIdLogin: refreshed.needsSageIdLogin,
        };
    }

    return { success: true, companies: refreshed.cache.companies };
};

export const runSync = (selectedCompanyIds, options = {}) =>
    runSyncFlow(selectedCompanyIds, options);

export { refreshSessionCache } from './refreshSessionCache';
export { ADMIN_CREATE_FAILED, BLOCKER_CODES, SYNC_ERROR_CODES } from './constants';
